module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-02-m-jp.57faebb1edb554c38cb6ea91e99dbbfc.png";